import React from 'react';

import { MobileThemedToggle } from '~/src/dash/components/toggles/MobileThemedToggle';
import { Col, Cols, spacing } from '~/src/dash/publicaUI';
import { defaultTimeRanges, ITimeRange } from '~/src/dash/utils/dateTimeRanges';

interface IMobileTimeRangeSelectorProps {
  timeRanges?: ITimeRange[];
  selectedRange: number;
  handleClick: (dateRange: number) => void;
}

export const MobileTimeRangeSelector = ({
  timeRanges = defaultTimeRanges,
  selectedRange,
  handleClick,
}: IMobileTimeRangeSelectorProps) => {
  return (
    <Cols
      gap={spacing.small}
      className='hide-scrollbar'
      style={{
        alignItems: 'center',
        overflowX: 'auto',
      }}
    >
      {timeRanges.map((range) => {
        return (
          <Col>
            <MobileThemedToggle
              active={range.value === selectedRange}
              onClick={() => handleClick(range.value)}
              size='small'
              value={range.shortLabel}
              style={{ textTransform: 'uppercase' }}
            />
          </Col>
        );
      })}
    </Cols>
  );
};
